import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  List,
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  DateFilter,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showSuccessMessage,
  showWarningMessage,
} from "../../../helper/message";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { assetLocationService } from "../../../apis/apiServices/AssetLocation";
import { UomService } from "../../../apis/apiServices/Uom";
import { useGetCodeWiseAppModuleFeaturePermission } from "../../../helper/sessionHelper";

export default function SaveAssetMaterialMovementRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    isSavingAsDraft: false,
    isMaterialDetailsSubmitted: false,
    isSending: false,
    materialMovementId: location?.state?.materialMrId ?? 0,
    materialMovementSubId: 0,
    materialMovementNo: location?.state?.stateData?.materialMovementNo ?? "",
    toProjectId: location?.state?.stateData?.toProjectId ?? 0,
    toProjectName: location?.state?.stateData?.toProjectName ?? "",
    toLocationName: location?.state?.stateData?.toLocationName ?? "",
    departmentId: location?.state?.stateData?.departmentId ?? 0,
    workflowCategoryId: location?.state?.stateData?.workFlowId ?? 0,
    subject: location?.state?.stateData?.materialMovementSubject ?? "",
    isAddMaterialInfoOpen: false,
    assetMaterialMovementRequestSubList: [],
    note: location?.state?.stateData?.note ?? "",
    vendorId: 0,
    vendorName: "",
    fromProjectId: 0,
    fromProjectName: "",
    fromLocationName: "",
    materialDesc: "",
    totalCapacityOfMaterials: 0,
    movementQuantity: 0,
    workOrderId: 0,
    workOrderNo: "",
    uomId: 0,
    uomName: "",
    remark: "",
    ownerTypeId: 0,
    ownerTypeName: "",
  });
  const [attachment, setAttachment] = useState({
    fileName: "",
    fileUrl: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
    uploadedTemporaryAssetMaterialMovementAttachmentLst:
      location.state?.stateData?.assetMaterialMovementAttachment ?? [],
  });
  const [errors, setErrors] = useState({
    toProjectValidation: "",
    departmentValidation: "",
    workflowCategoryValidation: "",
    subjectValidation: "",
    vendorValidation: "",
    materialDescValidation: "",
    totalCapacityOfMaterialsValidation: "",
    movementQuantityValidation: "",
    workOrderValidation: "",
    uomValidation: "",
    remarkValidation: "",
    fromProjectValidation: "",
    ownerTypeValidation: "",
  });
  const [
    assetMaterialMovementApproversByWorkflow,
    setAssetMaterialMovementApproversByWorkflow,
  ] = useState([]);
  const [assetMaterialMovementApprovers, setAssetMaterialMovementApprovers] =
    useState([]);
  const [toProjectDropdown, setToProjectDropdown] = useState([]);
  const [fromProjectDropdown, setFromProjectDropdown] = useState([]);
  const [workFlowCategoryDropdown, setWorkFlowCategoryDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [vendorDropdown, setVendorDropdown] = useState([]);
  const [workOrderDropdown, setWorkOrderDropdown] = useState([]);
  const [uomDropdown, setuomDropdown] = useState([]);
  const [ownerTypeDropdown, setOwnerTypeDropdown] = useState([]);
  let movementOrderfeaturePermission = useGetCodeWiseAppModuleFeaturePermission(
    "MaterialMovementOrder"
  );

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `${
      state.materialMovementId === 0
        ? `New Asset Material Movement Request`
        : `Edit Asset Material Movement Request - ${state.materialMovementNo}`
    }`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getToProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getDepartmentDropdown(state.toProjectId);
      }, 0);
      setTimeout(async () => {
        await getWorkflowCategory(state.toProjectId, state.departmentId);
      }, 0);
      setTimeout(async () => {
        await getAssetMaterialMovementSubLst(state.materialMovementId);
      }, 0);
      setTimeout(async () => {
        await GetWorkFlowForApprovers(
          state.workflowCategoryId,
          state.toProjectId,
          state.departmentId
        );
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetMaterialMovementSubLst = async (materialMrId) => {
    try {
      const response = await assetService.getAssetMaterialMovementSub(
        materialMrId
      );
      setState((prev) => ({
        ...prev,
        assetMaterialMovementRequestSubList: response?.data ?? [],
      }));
    } catch (error) {}
  };

  const GetWorkFlowForApprovers = async (
    formCategoryId,
    toProjectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        categoryId: formCategoryId || 0,
        projectId: toProjectId || 0,
        departmentId: departmentId || 0,
      };
      if (
        body.formId > 0 &&
        body.categoryId > 0 &&
        body.projectId > 0 &&
        body.departmentId > 0
      ) {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        const stagesWithApprovers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.map((stage) => ({
            actionTypeName: stage?.actionTypeName?.trim(),
            approvers: stage?.approvers,
          }));
        const Approvers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );
        setAssetMaterialMovementApproversByWorkflow(stagesWithApprovers);
        setAssetMaterialMovementApprovers(Approvers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getToProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectByUserId(user.userId, body);
      setToProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getFromProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectByUserId(user.userId, body);
      setFromProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getDepartmentDropdown = async (toProjectId) => {
    try {
      let body = {
        formId: props?.featurePermission?.featureId,
        projectId: toProjectId,
        companyId: user?.companyId,
      };
      const response = await vishwamApi.getDepartmentDropdownForWorkFlow(body);
      setDepartmentDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkflowCategory = async (projectId, departmentId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        projectId: projectId,
        departmentId: departmentId,
      };
      const response = await assetService.getWorkflowGroup(body);
      setWorkFlowCategoryDropdown(response?.data);
      if (response?.data.length === 1) {
        setState((prev) => ({
          ...prev,
          workflowCategoryId: response?.data[0].workflowCategoryId,
          workflowId: response?.data[0].workflowId,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getVendorDropdown = async () => {
    try {
      const response = await vishwamApi.getVendorList(user?.companyId);
      setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      //setVendorDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getUOMDropdown = async () => {
    try {
      const response = await UomService.getUomList();
      setuomDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getOwnerTypeDropdown = async () => {
    try {
      const ownershipTypeList = [
        { id: 1, name: "Purchase Order" },
        { id: 2, name: "Service Order" },
        { id: 3, name: "Others" },
        { id: 4, name: "Site To Site" },
      ];
      setOwnerTypeDropdown(ownershipTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkOrderDropdown = async (ownerTypeId, vendorId, projectId) => {
    try {
      const response = await assetService.getWorkOrderDropdown(
        ownerTypeId,
        vendorId,
        projectId
      );
      setWorkOrderDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleAssetMaterialMovementFileChange = async (e) => {
    try {
      setAttachment((prev) => ({ ...prev, fileData: "" }));
      const assetMaterialMovementAttachment = Array.from(e.target.files);
      const newAttachmentPromises = assetMaterialMovementAttachment.map(
        async (file) => {
          const base64 = await getBase64(file);
          return {
            noOfRows: Math.random().toString(16).slice(2),
            id: 0,
            materialMrId: state.materialMovementId,
            fileName: file.name,
            fileSize: file.size,
            filePath: "",
            fileUrl: "",
            fileData: base64,
            fileType: file.type,
            uploadDate: "",
          };
        }
      );
      const newAttachments = await Promise.all(newAttachmentPromises);
      setAttachment((prev) => {
        const existingList =
          prev.uploadedTemporaryAssetMaterialMovementAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryAssetMaterialMovementAttachmentLst: [
            ...existingList,
            ...newAttachments,
          ],
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  const isValidMaterialMovementData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.toProjectValidation = "";
      err.departmentValidation = "";
      err.workflowCategoryValidation = "";
      err.subjectValidation = "";
      if (state.toProjectId === 0) {
        isValid = false;
        err.toProjectValidation = "Please select project.";
      }
      if (state.departmentId === 0) {
        isValid = false;
        err.departmentValidation = "Please select department.";
      }
      if (state.workflowCategoryId === 0) {
        isValid = false;
        err.workflowCategoryValidation = "Please select workflow category.";
      }
      if (!state.subject) {
        isValid = false;
        err.subjectValidation = "Please enter subject.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const isValidMaterialMovementSubData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.vendorValidation = "";
      err.materialDescValidation = "";
      err.totalCapacityOfMaterialsValidation = "";
      err.movementQuantityValidation = "";
      err.workOrderValidation = "";
      err.uomValidation = "";
      err.remarkValidation = "";
      err.fromProjectValidation = "";
      err.ownerTypeValidation = "";
      if (state.vendorId === 0) {
        isValid = false;
        err.vendorValidation = "Please select vendor.";
      }
      if (!state.materialDesc) {
        isValid = false;
        err.materialDescValidation = "Please enter description.";
      }
      // if (
      //   state.totalCapacityOfMaterials === 0 ||
      //   !state.totalCapacityOfMaterials
      // ) {
      //   isValid = false;
      //   err.totalCapacityOfMaterialsValidation =
      //     "Please enter total capacity of materials.";
      // }
      if (state.movementQuantity === 0 || !state.movementQuantity) {
        isValid = false;
        err.movementQuantityValidation = "Please enter movement quantity.";
      }
      if (state.ownerTypeId === 0) {
        isValid = false;
        err.ownerTypeValidation = "Please select owner type.";
      }
      if (state.uomId === 0) {
        isValid = false;
        err.uomValidation = "Please select uom.";
      }
      if (state.ownerTypeId !== 3) {
        if (state.workOrderId === 0 && !state.workOrderNo) {
          isValid = false;
          err.workOrderValidation =
            state.ownerTypeId === 1
              ? "Please select purchase no."
              : state.ownerTypeId === 2
              ? "Please select work order no."
              : "Please select order no.";
        }
      } else {
        if (!state.workOrderNo) {
          isValid = false;
          err.workOrderValidation = "Please enter order no.";
        }
      }
      if (state.ownerTypeId !== 4) {
        if (
          state.fromProjectId === 0 &&
          !state.fromProjectName &&
          !state.fromLocationName
        ) {
          isValid = false;
          err.fromProjectValidation = "Please select project.";
        }
      } else {
        if (!state.fromLocationName) {
          isValid = false;
          err.fromProjectValidation = "Please enter from location.";
        }
      }
      if (!state.remark) {
        isValid = false;
        err.remarkValidation = "Please enter remark.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSendAssetMaterialMovementRequest = async (e, isSent) => {
    e.preventDefault();
    try {
      if (isValidMaterialMovementData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to send asset material movement for approval?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSending: true }));
        debugger;
        let workflowCategory = {};
        workflowCategory.formId = props.featurePermission.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.toProjectId;
        workflowCategory.departmentId = state.departmentId; // user.userDepartmentId;

        let body = {
          applicationId: 3,
          requestedDate: moment(new Date())
            .format(DefaultDateFormat.SqlDateFormat)
            .toString(),
          materialMrId: state.materialMovementId || 0,
          materialMrNo: state.materialMovementNo || "",
          materialMrSubject: state.subject || "",
          fromId: user?.userId,
          toProjectId: state.toProjectId || 0,
          toLocationName: state.toLocationName || "",
          departmentId: state.departmentId || 0,
          note: state.note || "",
          workFlowId: state.workflowId || 0,
          formId: props?.featurePermission?.featureId || 0,
          isSent: isSent,
          modifiedBy: user?.userId,
          assetMovementRequestSubLst: state.assetMaterialMovementRequestSubList,
          assetMaterialMovementAttachmentLst:
            attachment.uploadedTemporaryAssetMaterialMovementAttachmentLst,
          WorkflowCategoryRequest: workflowCategory,
          isLoginUserRequester:
            assetMaterialMovementApprovers?.[0]?.actionTypeId === 8
              ? false
              : true,
        };

        const response = await assetService.saveAssetMaterialMovementRequest(
          body
        );

        debugger;

        if (response?.isSuccess) {
          //setIsAssetMaterialMovementApproved(true);
          let workflowCategory = {};
          workflowCategory.formId = movementOrderfeaturePermission?.featureId;
          workflowCategory.categoryId = state.workflowCategoryId;
          workflowCategory.projectId = state?.toProjectId;
          workflowCategory.departmentId = state?.departmentId;

          let workflowCategoryId = 0;
          let categorybody = {
            formId: movementOrderfeaturePermission?.featureId,
            projectId: state.toProjectId ?? 0,
            departmentId: state.departmentId ?? 0,
          };
          const categoryresponse = await assetService.getWorkflowGroup(
            categorybody
          );
          if (categoryresponse?.data.length >= 1) {
            workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
          }
          let workflowData = await GetWorkFlowForApprovers(
            movementOrderfeaturePermission?.featureId,
            workflowCategoryId,
            state.toProjectId,
            state.departmentId
          );
          const stagesWithApprovers = workflowData?.stages
            ?.filter(
              (stage) => stage?.approvers && stage?.approvers?.length > 0
            )
            ?.map((stage) => ({
              actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
              approvers: stage?.approvers,
            }));
          const Approvers = workflowData?.stages
            ?.filter(
              (stage) => stage?.approvers && stage?.approvers?.length > 0
            )
            ?.flatMap((stage) =>
              stage?.approvers?.map((approver) => ({
                actionTypeId: stage?.actionTypeId,
                userId: approver?.userId,
                canEdit: approver?.canEdit,
                stageId: stage?.index,
              }))
            );
          let matchedStage = [];
          let highestStageItems = [];
          let maxStageId = 0;
          if (Approvers !== undefined) {
            maxStageId = Math?.max(...Approvers?.map((item) => item.stageId));

            highestStageItems = Approvers?.filter(
              (item) => item.stageId === maxStageId
            );
            matchedStage = highestStageItems?.filter(
              (e) => e.userId === user?.userId
            );
          }

          let approveBody = {
            materialMrId: state?.materialMovementId ?? 0,
            userId: user?.userId ?? 0,
            formId: location?.state?.formId ?? 0,
            remark: state.remark, //state.remark,
            departmentId: state?.departmentId ?? 0,
            applicationId: 3,
            workflowId: state.workflowCategoryId ?? 0,
            orderFormName: "Movement Order",
            orderFormId: movementOrderfeaturePermission?.featureId,
            isLoginUserRequester:
              Approvers?.[0]?.actionTypeId === 8 ? false : true,
            workflowCategoryRequest: workflowCategory,
            isMatchedStage: matchedStage?.length > 0 ? true : false,
          };
          const response =
            await assetService.approveAssetMaterialMovementRequest(approveBody);
          isConfirmed = await showResponseMessage(response);
          //setIsAssetMaterialMovementApproved(false);

          setState((prev) => ({ ...prev, isSending: false }));

          if (response?.isSuccess) {
            navigate("/MaterialMovementRequest");
          }
        }
        // const response = await assetService.saveAssetMaterialMovementRequest(
        //   body
        // );
        // isConfirmed = await showResponseMessage(response);
        // setState((prev) => ({ ...prev, isSending: false }));
        // if (response?.isSuccess) {
        //   navigate("/MaterialMovementRequest");
        // }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSending: false }));
      console.log(error);
    }
  };

  const handleOnSaveAssetMaterialMovementRequest = async (e, isSent) => {
    e.preventDefault();
    try {
      if (isValidMaterialMovementData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to ${
          state.materialMovementId === 0 ? "add" : "update"
        } asset material movement request?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );

        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));
        if (state.assetMaterialMovementRequestSubList?.length === 0) {
          setState((prev) => ({ ...prev, isSavingAsDraft: false }));
          await showErrorMessage(`Please add at least one material details!!`);
          return;
        }

        let workflowCategory = {};
        workflowCategory.formId = props.featurePermission.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.toProjectId;
        workflowCategory.departmentId = state.departmentId; // user.userDepartmentId;

        let body = {
          applicationId: 3,
          requestedDate: moment(new Date())
            .format(DefaultDateFormat.SqlDateFormat)
            .toString(),
          materialMrId: state.materialMovementId || 0,
          materialMrNo: state.materialMovementNo || "",
          materialMrSubject: state.subject || "",
          fromId: user?.userId,
          toProjectId: state.toProjectId || 0,
          toLocationName: state.toLocationName || "",
          departmentId: state.departmentId || 0,
          note: state.note || "",
          workFlowId: state.workflowId || 0,
          formId: props?.featurePermission?.featureId || 0,
          isSent: isSent,
          modifiedBy: user?.userId,
          assetMovementRequestSubLst: state.assetMaterialMovementRequestSubList,
          assetMaterialMovementAttachmentLst:
            attachment.uploadedTemporaryAssetMaterialMovementAttachmentLst,
          WorkflowCategoryRequest: workflowCategory,
          isLoginUserRequester:
            assetMaterialMovementApprovers?.[0]?.actionTypeId === 8
              ? false
              : true,
        };

        debugger;

        debugger;
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));

        const response = await assetService.saveAssetMaterialMovementRequest(
          body
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        if (response?.isSuccess) {
          navigate("/MaterialMovementRequest");
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.log(error);
    }
  };

  const handleOnAddMaterialMovementRequestSub = async (e) => {
    e.preventDefault();
    try {
      if (isValidMaterialMovementSubData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to add movement details?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isMaterialDetailsSubmitted: true }));
        let assetMaterialMovementRequestSubList = [
          ...state.assetMaterialMovementRequestSubList,
        ];
        let assetMaterialMovementRequestSubSourceLst = {};
        assetMaterialMovementRequestSubSourceLst.noOfRows = Math.random()
          .toString(16)
          .slice(2);
        assetMaterialMovementRequestSubSourceLst.materialMrSubId =
          state.materialMovementSubId;
        assetMaterialMovementRequestSubSourceLst.materialMrId =
          state.materialMovementId;
        assetMaterialMovementRequestSubSourceLst.fromProjectId =
          state.fromProjectId;
        assetMaterialMovementRequestSubSourceLst.fromProjectName =
          state.fromProjectName;
        assetMaterialMovementRequestSubSourceLst.fromLocationName =
          state.fromLocationName;
        assetMaterialMovementRequestSubSourceLst.vendorId = state.vendorId;
        assetMaterialMovementRequestSubSourceLst.vendorName = state.vendorName;
        assetMaterialMovementRequestSubSourceLst.materialDescription =
          state.materialDesc;
        assetMaterialMovementRequestSubSourceLst.totalCapacityOfMaterials =
          state.totalCapacityOfMaterials;
        assetMaterialMovementRequestSubSourceLst.movementQuantity =
          state.movementQuantity;
        assetMaterialMovementRequestSubSourceLst.workOrderId =
          state.workOrderId;
        assetMaterialMovementRequestSubSourceLst.workOrderNo =
          state.workOrderNo;
        assetMaterialMovementRequestSubSourceLst.ownerTypeId =
          state.ownerTypeId;
        assetMaterialMovementRequestSubSourceLst.ownerTypeName =
          state.ownerTypeName;
        assetMaterialMovementRequestSubSourceLst.uomId = state.uomId;
        assetMaterialMovementRequestSubSourceLst.uomName = state.uomName;
        assetMaterialMovementRequestSubSourceLst.remark = state.remark;
        assetMaterialMovementRequestSubSourceLst.statusId = 0;
        assetMaterialMovementRequestSubSourceLst.statusName = "";
        if (state.materialMovementSubId > 0) {
          const index = assetMaterialMovementRequestSubList.findIndex(
            (item) =>
              (item.materialMrSubId &&
                item.materialMrSubId ===
                  assetMaterialMovementRequestSubSourceLst.materialMrSubId) ||
              (!item.materialMrSubId &&
                item.noOfRows ===
                  assetMaterialMovementRequestSubSourceLst.noOfRows)
          );
          if (index !== -1) {
            assetMaterialMovementRequestSubList[index] =
              assetMaterialMovementRequestSubSourceLst;
          }
        } else {
          assetMaterialMovementRequestSubList.push(
            assetMaterialMovementRequestSubSourceLst
          );
        }
        setState((prev) => ({
          ...prev,
          assetMaterialMovementRequestSubList:
            assetMaterialMovementRequestSubList,
        }));
        handleOnCloseSaveMaterialMovementDetailsModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isMaterialDetailsSubmitted: false }));
    }
  };

  const handleOnOpenEditMaterialMovementDetailsModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isAddMaterialInfoOpen: true,
        materialMovementSubId: data?.materialMrSubId,
        materialMovementId: data?.materialMrId,
        vendorId: data?.vendorId ?? 0,
        vendorName: data?.vendorName ?? "",
        fromProjectId: data?.fromProjectId ?? 0,
        fromProjectName: data?.fromProjectName ?? "",
        fromLocationName: data?.fromLocationName ?? "",
        materialDesc: data?.materialDescription ?? "",
        totalCapacityOfMaterials: data?.totalCapacityOfMaterials ?? 0,
        movementQuantity: data?.movementQuantity ?? 0,
        workOrderId: data?.workOrderId ?? 0,
        workOrderNo: data?.workOrderNo ?? "",
        uomId: data?.uomId ?? 0,
        uomName: data?.uomName ?? "",
        remark: data?.remark ?? "",
        ownerTypeId: data?.ownerTypeId ?? 0,
        ownerTypeName: data?.ownerTypeName ?? "",
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseSaveMaterialMovementDetailsModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        materialMovementSubId: 0,
        vendorId: 0,
        vendorName: "",
        fromProjectId: 0,
        fromProjectName: "",
        fromLocationName: "",
        materialDesc: "",
        totalCapacityOfMaterials: 0,
        movementQuantity: 0,
        workOrderId: 0,
        workOrderNo: "",
        uomId: 0,
        uomName: "",
        remark: "",
        ownerTypeId: 0,
        ownerTypeName: "",
        isAddMaterialInfoOpen: false,
      }));
      setVendorDropdown([]);
      setWorkOrderDropdown([]);
      setuomDropdown([]);
      setOwnerTypeDropdown([]);
      setFromProjectDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div
          className="card"
          style={{ borderRadius: "6px", marginTop: "-10px" }}
        >
          <div
            className="card-header p-2"
            style={{
              backgroundColor: "#e3e7ff",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                From&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {user?.userDepartmentName}
                </strong>
                &nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {moment(DateFilter.CurrentDateTime)
                    .format(DefaultDateFormat.MomentDisplayDateTime24AMPFormat)
                    .toString()}
                </strong>
              </h6>
            </div>
            <div className="float-right">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => {
                  navigate("/MaterialMovementRequest");
                }}
              >
                <span title="Cancel ">
                  <i className="fas fa-times" />
                  &nbsp;&nbsp;Cancel
                </span>
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  await handleOnSaveAssetMaterialMovementRequest(e, false);
                }}
                disabled={state.isSavingAsDraft}
              >
                <span title="Save As Draft">
                  <i
                    className={`fas fa-${
                      state.isSavingAsDraft
                        ? "spinner fa-spin"
                        : "file-signature"
                    }`}
                  />
                  &nbsp;&nbsp;Save As Draft
                </span>
              </button>
              {state.materialMovementId > 0 && (
                <>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnSendAssetMaterialMovementRequest(e, true);
                    }}
                    disabled={state.isSending}
                  >
                    <span title="Send">
                      <i
                        className={`fas fa-${
                          state.isSending ? "spinner fa-spin" : "check"
                        }`}
                      />
                      &nbsp;&nbsp;Send for Approval
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className={`col-12 col-lg-${state.toLocationName ? 3 : 4}`}>
                <div className="form-group mb-2">
                  <label>
                    Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={toProjectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select project"
                    name="toProjectDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.toProjectId}
                    defaultValue={state.toProjectId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.toProjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        toProjectId: e?.selectedItem?.id ?? 0,
                        toProjectName: e?.selectedItem?.name ?? "",
                        toLocationName: "",
                        departmentId: 0,
                      }));
                      setDepartmentDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getDepartmentDropdown(e?.selectedItem?.id);
                        const response =
                          await assetLocationService.getLocationList(
                            e?.selectedItem?.id
                          );
                        setState((prev) => ({
                          ...prev,
                          toLocationName:
                            response?.data
                              ?.filter(
                                (f) => f.projectId === e?.selectedItem?.id
                              )
                              ?.map((a) => a.name)
                              ?.join(", ") ?? "",
                        }));
                      }
                    }}
                  />
                  {errors.toProjectValidation && (
                    <div className="text-danger">
                      {errors.toProjectValidation}
                    </div>
                  )}
                </div>
              </div>
              {state.toLocationName && (
                <>
                  <div
                    className={`col-12 col-lg-${state.toLocationName ? 3 : 4}`}
                    style={{ display: "none" }}
                  >
                    <div className="form-group mb-2">
                      <label>Location</label>
                      <TextBox
                        className="form-control form-control-sm"
                        height={37}
                        readOnly={true}
                        value={state.toLocationName}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className={`col-12 col-lg-${state.toLocationName ? 3 : 4}`}>
                <div className="form-group mb-2">
                  <label>
                    Department<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={departmentDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select department"
                    name="departmentDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.departmentId}
                    defaultValue={state.departmentId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.departmentValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        departmentId: e?.selectedItem?.id ?? 0,
                        workflowCategoryId: 0,
                      }));
                      setWorkFlowCategoryDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getWorkflowCategory(
                          state.toProjectId,
                          e?.selectedItem?.id
                        );
                      }
                    }}
                  />
                  {errors.departmentValidation && (
                    <div className="text-danger">
                      {errors.departmentValidation}
                    </div>
                  )}
                </div>
              </div>
              {workFlowCategoryDropdown?.length > 0 && (
                <>
                  <div
                    className={`col-12 col-lg-${state.toLocationName ? 3 : 4}`}
                    style={{ display: "none" }}
                  >
                    <div className="form-group mb-2">
                      <label>
                        Category&nbsp;<span className="text-danger">*</span>
                      </label>
                      <SelectBox
                        dataSource={workFlowCategoryDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select category"
                        name="workFlowCategoryDropdown"
                        displayExpr="name"
                        valueExpr="workflowCategoryId"
                        value={state.workflowCategoryId}
                        defaultValue={state.workflowCategoryId}
                        showClearButton={true}
                        disabled={false}
                        readOnly={false}
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.workflowCategoryValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            workflowCategoryId:
                              e?.selectedItem?.workflowCategoryId ?? 0,
                          }));
                          setAssetMaterialMovementApproversByWorkflow([]);
                          if (e?.selectedItem?.workflowCategoryId > 0) {
                            await GetWorkFlowForApprovers(
                              e?.selectedItem?.workflowCategoryId,
                              state.toProjectId,
                              state.departmentId
                            );
                          }
                        }}
                      />
                      {errors.workflowCategoryValidation && (
                        <div className="text-danger">
                          {errors.workflowCategoryValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="form-group mb-2">
                  <label>
                    Subject&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter subject"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.subject}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.subjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        subject: e?.value,
                      }));
                    }}
                  />
                  {errors.subjectValidation && (
                    <div className="text-danger">
                      {errors.subjectValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    dataSource={state.assetMaterialMovementRequestSubList}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={false}
                    height={250}
                    onToolbarPreparing={(e) => {
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        template: "toolbarAddTemplate",
                      });
                    }}
                  >
                    <Column
                      dataField=""
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={50}
                      cellRender={(data) => {
                        const idPrefix = `icon-${
                          data?.data?.materialMrSubId === 0
                            ? data?.data?.noOfRows
                            : data?.data?.materialMrSubId
                        }`;
                        return (
                          <>
                            <div style={{ display: "flex" }}>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit Material Details"
                                  tooltip="Edit Material Details"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    await handleOnOpenEditMaterialMovementDetailsModal(
                                      e,
                                      data?.data
                                    );
                                  }}
                                />
                              </span>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-delete`}
                                  className="iconify-size mr-1"
                                  title="Delete"
                                  tooltip="Delete"
                                  icon="fluent:delete-32-regular"
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    try {
                                      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete material movement ${data?.data?.workOrderNo}?</span>`;
                                      let isConfirmed = await askConfirmation(
                                        confirmationQuestion,
                                        "Yes",
                                        "No"
                                      );
                                      if (!isConfirmed) return;
                                      if (data?.data?.noOfRows) {
                                        setState((prev) => ({
                                          ...prev,
                                          assetMaterialMovementRequestSubList:
                                            state.assetMaterialMovementRequestSubList?.filter(
                                              (f) =>
                                                f.noOfRows !==
                                                data?.data?.noOfRows
                                            ),
                                        }));
                                        isConfirmed = await showSuccessMessage(
                                          `Material movement ${data?.data?.workOrderNo} is deleted successfully!!`
                                        );
                                      } else if (
                                        data.data?.materialMrSubId > 0
                                      ) {
                                        const response =
                                          await assetService.deleteAssetMaterialMovementSub(
                                            data?.data?.materialMrSubId
                                          );
                                        isConfirmed = await showResponseMessage(
                                          response
                                        );
                                        if (response?.isSuccess) {
                                          await getAssetMaterialMovementSubLst(
                                            data?.data?.materialMrId
                                          );
                                        }
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                />
                              </span>
                            </div>
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="vendorName"
                      caption="Vendor"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="fromLocationName"
                      caption="From Location"
                      allowSearch={true}
                      allowSorting={true}
                      calculateCellValue={(data) => {
                        return `${data?.data?.fromLocationName || ""} ${
                          data?.data?.fromProjectName || ""
                        }`;
                      }}
                      cellRender={(data) => {
                        return (
                          <>
                            {data?.data?.ownerTypeId !== 4 ? (
                              <>
                                <span>
                                  {data?.data?.fromLocationName ?? ""}
                                </span>
                              </>
                            ) : (
                              <>
                                <span>{data?.data?.fromProjectName ?? ""}</span>
                              </>
                            )}
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="workOrderNo"
                      caption="Work Order No"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="materialDescription"
                      caption="Material Description"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="uomName"
                      caption="UOM"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="movementQuantity"
                      caption="Quantity"
                      allowSearch={true}
                      allowSorting={true}
                      alignment={"center"}
                    />

                    {/* <Column
                    dataField="totalCapacityOfMaterials"
                    caption="Total Capacity Of Materials"
                    allowSearch={true}
                    allowSorting={true}
                    alignment={"center"}
                  /> */}

                    <Column
                      dataField="remark"
                      caption="Remark"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Template
                      name="toolbarAddTemplate"
                      render={() => {
                        return (
                          <>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={async () => {
                                if (
                                  state.toProjectId === 0 ||
                                  state.departmentId === 0
                                ) {
                                  await showWarningMessage(
                                    "Please select project and department"
                                  );
                                  return;
                                }
                                if (
                                  state.assetMaterialMovementRequestSubList
                                    ?.length === 1
                                ) {
                                  await showWarningMessage(
                                    "You can add only one materials details at a time!!"
                                  );
                                  return;
                                }
                                setState((prev) => ({
                                  ...prev,
                                  isAddMaterialInfoOpen: true,
                                }));
                              }}
                            >
                              <span title="Add Asset">
                                <i className="fas fa-plus" />
                                &nbsp;&nbsp;Add Material Info
                              </span>
                            </button>
                          </>
                        );
                      }}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="virtual" />
                    <SearchPanel
                      visible={true}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label
                    htmlFor="fileUpload"
                    className="btn btn-outline-primary mb-1"
                    style={{ cursor: "pointer" }}
                    title="Attachment"
                  >
                    <i class="fas fa-plus"></i>&nbsp;Attachment
                  </label>
                  <input
                    id="fileUpload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={async (e) => {
                      await handleAssetMaterialMovementFileChange(e);
                    }}
                  />
                </div>
                <div className="attachment-container">
                  {attachment?.uploadedTemporaryAssetMaterialMovementAttachmentLst?.map(
                    (file, idx) => (
                      <div key={idx} className="attachment-item">
                        <div
                          class="d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            className="attachment-name"
                            onClick={() => {
                              if (file?.filePath) {
                                window.open(file?.fileUrl, "_blank");
                              }
                            }}
                          >
                            {file?.fileName}
                          </div>
                          {file?.id === 0 && (
                            <button
                              className="btn pt-0 pb-0 pr-0"
                              onClick={() => {
                                setAttachment((prev) => ({
                                  ...prev,
                                  uploadedTemporaryAssetMaterialMovementAttachmentLst:
                                    attachment.uploadedTemporaryAssetMaterialMovementAttachmentLst?.filter(
                                      (_, i) => i !== idx
                                    ),
                                }));
                              }}
                            >
                              <i class="fas fa-times"></i>
                            </button>
                          )}
                        </div>
                        <div className="small">
                          {(file?.fileSize / 1024).toFixed(0)} kb
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>Note</label>
                  <TextArea
                    className="form-control form-control-sm"
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.note}
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        note: e.value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>Prepared By</label>
                  {state?.materialMovementId > 0 ? (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        location?.state?.stateData?.fromName +
                        " (" +
                        location?.state?.stateData?.fromDesginationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  ) : (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        user?.firstName +
                        " " +
                        user?.lastName +
                        " (" +
                        user?.userDesignationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  )}
                </div>
              </div> */}

              {assetMaterialMovementApprovers?.[0]?.actionTypeId === 8 ? "" :
                <>
                  <div className="col-lg-4 col-md-12 col-sm-4">
                    <div className='form-group'>
                      {assetMaterialMovementApprovers?.[0]?.actionTypeId === 8 ? ("") : (<label>Prepared By</label>)}
                      {assetMaterialMovementApprovers?.id ? (
                        <TextBox
                          className="form-control"
                          placeholder="Enter name"
                          showClearButton={false}
                          value={assetMaterialMovementApprovers?.fromUser + " (" + assetMaterialMovementApprovers?.fromUserDesignation + ")"}
                          readOnly={true}
                        />)
                        :
                        assetMaterialMovementApprovers?.[0]?.actionTypeId === 8 ? (
                          "")
                          :
                          (<TextBox
                            className="form-control"
                            placeholder="Enter name"
                            showClearButton={false}
                            value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                            readOnly={true}
                          />)
                      }
                    </div>
                  </div>
                </>
              }

              {assetMaterialMovementApproversByWorkflow?.map((stage, index) => (
                <div
                  key={index}
                  className="col-12 col-lg-4 d-flex align-items-start"
                >
                  <div className="w-100">
                    <label className="form-label">
                      {stage?.actionTypeName}
                    </label>
                    {stage?.approvers?.map((approver, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        value={`${approver?.userName} (${approver?.designationName})`}
                        readOnly={true}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isAddMaterialInfoOpen}
        onAfterOpen={async () => {
          await getFromProjectDropdown();
          await getVendorDropdown();
          await getUOMDropdown();
          await getOwnerTypeDropdown();
          //await getWorkOrderDropdown(state.ownerTypeId);
          let err = { ...errors };
          err.vendorValidation = "";
          err.materialDescValidation = "";
          err.totalCapacityOfMaterialsValidation = "";
          err.movementQuantityValidation = "";
          err.workOrderValidation = "";
          err.uomValidation = "";
          err.remarkValidation = "";
          err.fromProjectValidation = "";
          err.ownerTypeValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add/Edit Movement Details"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`${
            state.materialMovementSubId > 0
              ? `Update Movement Details For Work Order No - [${state.workOrderNo}] And For Owner Type - [${state.ownerTypeName}]`
              : `Add Movement Details`
          }`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseSaveMaterialMovementDetailsModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Vendor&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={vendorDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select vendor"
                  name="vendorDropdown"
                  displayExpr="vendorName"
                  valueExpr="id"
                  value={state.vendorId}
                  defaultValue={state.vendorId}
                  showClearButton={true}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.vendorValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      vendorId: e?.selectedItem?.id ?? 0,
                      vendorName: e?.selectedItem?.vendorName ?? "",
                    }));

                    setWorkOrderDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getWorkOrderDropdown(
                        state.ownerTypeId,
                        e?.selectedItem?.id,
                        state.toProjectId
                      );
                    }
                  }}
                />
                {errors.vendorValidation && (
                  <div className="text-danger">{errors.vendorValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  Service Type&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={ownerTypeDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select owner type"
                  name="ownerTypeDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.ownerTypeId}
                  defaultValue={state.ownerTypeId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.ownerTypeValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      ownerTypeId: e?.selectedItem?.id ?? 0,
                      ownerTypeName: e?.selectedItem?.name ?? "",
                      workOrderId: 0,
                      workOrderNo: "",
                      uomId:
                        e?.selectedItem?.id === 1 || e?.selectedItem?.id === 2
                          ? 9
                          : 0,
                      uomName:
                        e?.selectedItem?.id === 1 || e?.selectedItem?.id === 2
                          ? "Number"
                          : "",
                      movementQuantity:
                        e?.selectedItem?.id === 1 || e?.selectedItem?.id === 2
                          ? 1
                          : 0,
                    }));
                    setWorkOrderDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getWorkOrderDropdown(
                        e?.selectedItem?.id,
                        state.vendorId,
                        state.toProjectId
                      );
                    }
                  }}
                />
                {errors.ownerTypeValidation && (
                  <div className="text-danger">
                    {errors.ownerTypeValidation}
                  </div>
                )}
              </div>
            </div>
            {state.ownerTypeId !== 3 && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>
                      {`${
                        state.ownerTypeId === 1
                          ? `Purchase Order No`
                          : state.ownerTypeId === 2
                          ? `Work Order No`
                          : `Order No`
                      }`}
                      &nbsp;<span className="text-danger">*</span>
                    </label>
                    <SelectBox
                      dataSource={workOrderDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder={`${
                        state.ownerTypeId === 1
                          ? `Select Purchase Order`
                          : state.ownerTypeId === 2
                          ? `Select Work Order`
                          : `Select Order`
                      }`}
                      name="workOrderDropdown"
                      displayExpr="code"
                      valueExpr="id"
                      value={state.workOrderId}
                      defaultValue={state.workOrderId}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.workOrderValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          workOrderId: e?.selectedItem?.id ?? 0,
                          workOrderNo: e?.selectedItem?.code ?? "",
                          materialDesc: e?.selectedItem?.name ?? "",
                        }));
                      }}
                    />
                    {errors.workOrderValidation && (
                      <div className="text-danger">
                        {errors.workOrderValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {state.ownerTypeId === 3 && (
              <>
                <div className="col-12 col-lg-3">
                  <div className="form-group mb-2">
                    <label>
                      Order No&nbsp;<span className="text-danger">*</span>
                    </label>
                    <TextBox
                      className="form-control form-control-sm"
                      placeholder="Enter order no"
                      name="workOrderNo"
                      showClearButton={true}
                      height={37}
                      valueChangeEvent="keyup"
                      value={state.workOrderNo}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.workOrderValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          workOrderNo: e.value,
                        }));
                      }}
                    />
                    {errors.workOrderValidation && (
                      <div className="text-danger">
                        {errors.workOrderValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Description&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <TextBox
                  className="form-control form-control-sm"
                  placeholder="Enter Description"
                  name="materialDesc"
                  showClearButton={true}
                  height={37}
                  valueChangeEvent="keyup"
                  value={state.materialDesc}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.materialDescValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      materialDesc: e.value,
                    }));
                  }}
                />
                {errors.materialDescValidation && (
                  <div className="text-danger">
                    {errors.materialDescValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  UOM&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={uomDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select uom"
                  name="uomDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.uomId}
                  defaultValue={state.uomId}
                  showClearButton={true}
                  disabled={
                    state.ownerTypeId === 1 || state.ownerTypeId === 2
                      ? true
                      : false
                  }
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.uomValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      uomId: e?.selectedItem?.id ?? 0,
                      uomName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.uomValidation && (
                  <div className="text-danger">{errors.uomValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3" style={{ display: "none" }}>
              <div className="form-group mb-2">
                <label>
                  Total Capacity Of Materials&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <NumberBox
                  name="totalCapacityOfMaterials"
                  height={37}
                  className="form-control form-control-sm"
                  placeholder="Enter total capacity of materials"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.totalCapacityOfMaterialsValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      totalCapacityOfMaterials: e.value ?? 0,
                    }));
                  }}
                  value={Number(state.totalCapacityOfMaterials ?? 0) || ""}
                />
                {errors.totalCapacityOfMaterialsValidation && (
                  <div className="text-danger">
                    {errors.totalCapacityOfMaterialsValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  Quantity&nbsp;<span className="text-danger">*</span>
                </label>
                <NumberBox
                  name="movementQuantity"
                  height={37}
                  className="form-control form-control-sm"
                  placeholder="Enter movement quantity"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  disabled={
                    state.ownerTypeId === 1 || state.ownerTypeId === 2
                      ? true
                      : false
                  }
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.movementQuantityValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      movementQuantity: e.value ?? 0,
                    }));
                  }}
                  value={Number(state.movementQuantity ?? 0) || ""}
                />
                {errors.movementQuantityValidation && (
                  <div className="text-danger">
                    {errors.movementQuantityValidation}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            {state.ownerTypeId === 4 && (
              <>
                <div className="col-12 col-lg-6">
                  <div className="form-group mb-2">
                    <label>
                      From Project&nbsp;<span className="text-danger">*</span>
                    </label>
                    <SelectBox
                      dataSource={fromProjectDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select project"
                      name="fromProjectDropdown"
                      displayExpr="name"
                      valueExpr="id"
                      value={state.fromProjectId}
                      defaultValue={state.fromProjectId}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.fromProjectValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          fromProjectId: e?.selectedItem?.id ?? 0,
                          fromProjectName: e?.selectedItem?.name ?? "",
                          fromLocationName: "",
                        }));
                        if (e?.selectedItem?.id > 0) {
                          const response =
                            await assetLocationService.getLocationList(
                              e?.selectedItem?.id
                            );
                          setState((prev) => ({
                            ...prev,
                            fromLocationName:
                              response?.data
                                ?.filter(
                                  (f) => f.projectId === e?.selectedItem?.id
                                )
                                ?.map((a) => a.name)
                                ?.join(", ") ?? "",
                          }));
                        }
                      }}
                    />
                    {state.fromLocationName && (
                      <div style={{ color: "#414040ff", fontSize: "11px" }}>
                        <b>{state.fromLocationName}</b>
                      </div>
                    )}
                    {errors.fromProjectValidation && (
                      <div className="text-danger">
                        {errors.fromProjectValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {state.ownerTypeId !== 4 && (
              <>
                <div className="col-12 col-lg-6">
                  <div className="form-group mb-2">
                    <label>
                      From Location&nbsp;<span className="text-danger">*</span>
                    </label>
                    <TextBox
                      className="form-control form-control-sm"
                      placeholder="Enter from location"
                      name="fromLocationName"
                      showClearButton={true}
                      height={37}
                      valueChangeEvent="keyup"
                      value={state.fromLocationName}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.fromProjectValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          fromLocationName: e.value,
                        }));
                      }}
                    />
                    {errors.fromProjectValidation && (
                      <div className="text-danger">
                        {errors.fromProjectValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  To Project&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={toProjectDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select project"
                  name="toProjectDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.toProjectId}
                  defaultValue={state.toProjectId}
                  showClearButton={true}
                  disabled={false}
                  readOnly={true}
                  searchEnabled={true}
                />
                {state.toLocationName && (
                  <div style={{ color: "#414040ff", fontSize: "11px" }}>
                    <b>{state.toLocationName}</b>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <TextBox
                  className="form-control form-control-sm"
                  placeholder="Enter remark"
                  name="remark"
                  height={37}
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseSaveMaterialMovementDetailsModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnAddMaterialMovementRequestSub(e);
            }}
            disabled={state.isMaterialDetailsSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isMaterialDetailsSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
        </div>
      </Modal>
    </>
  );
}
